/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import ServiceCardDownloader from '../../components/ServiceCardDownloader/ServiceCardDownloader';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import v from './validators';
import loadingData from './loading';
import agentConfig from './agent';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const worktypeOptions = [
  {
    label: 'lokalizacja',
    value: 'lokalizację',
    state: 'typZezwolenia',
  },
  {
    label: 'przebudowa',
    value: 'przebudowę',
    state: 'typZezwolenia',
  },
];

const roadtypeOptions = [
  {
    label: 'indywidualny',
    value: 'indywidualnego',
    state: 'rodzajZjazdu',
  },
  {
    label: 'publiczny',
    value: 'publicznego',
    state: 'rodzajZjazdu',
  },
];

const timeOptions = [
  {
    label: 'nieokreślony',
    value: 'nieokreślony',
    state: 'time',
  },
  {
    label: 'określony',
    value: 'określony',
    state: 'time',
  },
];

const usingOptions = [
  {
    label: 'nie ulegnie zmianie',
    value: 'nie ulegnie zmianie',
    state: 'uzytkowanieZmiana',
  },
  {
    label: 'ulegnie zmianie',
    value: 'ulegnie zmianie',
    state: 'uzytkowanieZmiana',
  },
];

const ownershipOptions = [
  {
    label: 'właścicielem w/w nieruchomości',
    value: 'właścicielem',
    state: 'wladanie',
  },
  {
    label: 'użytkownikiem wieczystym w/w nieruchomości',
    value: 'użytkownikiem wieczystym',
    state: 'wladanie',
  },
  {
    label: 'użytkownikiem w/w nieruchomości',
    value: 'użytkownikiem',
    state: 'wladanie',
  },
  {
    label: 'zarządcą w/w nieruchomości',
    value: 'zarządcą',
    state: 'wladanie',
  },
  {
    label: 'dzierżawcą w/w nieruchomości',
    value: 'dzierżawcą',
    state: 'wladanie',
  },
];

const changeDict = {
  typZezwolenia: {
    label: 'Rodzaj działania',
    editable: true,
    type: 'Select',
    options: worktypeOptions,
  },
  rodzajZjazdu: {
    label: 'Rodzaj zjazdu',
    editable: true,
    type: 'Select',
    options: roadtypeOptions,
  },
  pasDrogowy: {
    label: 'Zjazd zawarty w pasie drogowym ulic (wymienić ulice)',
    editable: true,
    type: 'textarea',
  },
  wladanie: {
    label: 'Oświadczam, że jestem',
    editable: true,
    type: 'Select',
    options: ownershipOptions,
  },
  wykorzystanie: {
    label: 'Nieruchomość jest wykorzystywana na cele',
    editable: true,
    type: 'textarea',
  },
};

const czasDict = {
  time: {
    label: 'Czas zezwolenia',
    editable: true,
    type: 'Select',
    options: timeOptions,
  },
  dataDo: {
    label: 'Zezwolenie do dnia (jeśli czas zezwolenia jest określony)',
    editable: true,
  },
};

const sizeDict = {
  dlugosc: {
    label: 'Długość [m]',
    editable: true,
  },
  szerokosc: {
    label: 'Szerokość [m]',
    editable: true,
  },
  powierzchnia: {
    label: 'Powierzchnia [m2]',
    editable: true,
  },
};

const usingDict = {
  uzytkowanieZmiana: {
    label: 'Po zakończeniu pracy sposób wykorzystania w/w nieruchomości',
    editable: true,
    type: 'Select',
    options: usingOptions,
  },
  opisZmiany: {
    label: 'Opis zmiany (jeżeli sposób wykorzystania w/w nieruchomości ulegnie zmianie)',
    editable: true,
    type: 'textarea',
  },
};


class WykonanieZjazduZDrogi extends React.Component {
  state = {
    info: {
      typZezwolenia: null,
      rodzajZjazdu: null,
      pasDrogowy: null,
      wladanie: null,
      wykorzystanie: null,
      time: null,
      dataDo: null,
      uzytkowanieZmiana: null,
      opisZmiany: null,
      dlugosc: null,
      szerokosc: null,
      powierzchnia: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  validators = {
    typZezwolenia: [v.NotSelected],
    rodzajZjazdu: [v.NotSelected],
    pasDrogowy: [v.NotNull],
    wladanie: [v.NotSelected],
    wykorzystanie: [v.NotNull],
    time: [v.NotSelected],
    uzytkowanieZmiana: [v.NotSelected],
    dlugosc: [v.NotNull, v.isNumber],
    szerokosc: [v.NotNull, v.isNumber],
    powierzchnia: [v.NotNull, v.isNumber],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.setState({ isMounted: true });
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });


  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  insertTestData = () => {
    this.setState({
      info: {
        typZezwolenia: 'lokalizację',
        rodzajZjazdu: 'indywidualnego',
        pasDrogowy: 'Od ul. Testowej do ul. Zielonej',
        wladanie: 'właścicielem',
        wykorzystanie: 'działka budowlana',
        time: 'określony',
        dataDo: '2020-11-11',
        uzytkowanieZmiana: 'ulegnie zmianie',
        opisZmiany: 'z działki rolniczej na budowlaną',
        dlugosc: '50',
        szerokosc: '5',
        powierzchnia: '250',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });

      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />
        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ color: 'red' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={changeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <DecisionContainer
          title={'3. Parametry zjazdu'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={sizeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <DecisionContainer
          title={'4. Informacje dotyczące czasu wydania zezwolenia'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={czasDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <DecisionContainer
          title={'5. Informacje dotyczące zmiany sposobu wykorzystania nieruchomości'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={usingDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
              <p>1. Szczegółowy plan sytuacyjny w skali 1:1000/1:500 z projektem zagospodarowania terenu, z zaznaczoną lokalizacją zjazdu i jego wymiarami, oraz naniesionymi granicami działek,
                (plan sytuacyjny - tzw. podkład geodezyjny - można nabyć w Ośrodku Dokumentacji Geodezyjnej i Kartograficznej)</p>
              <p>2. Pełnomocnictwo - z oryginałem dokumentu potwierdzającego wniesienie opłaty skarbowej</p>
              <p>3. Dodatkowe dokumenty na żądanie zarządcy drogi</p>
            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
              <ServiceCardDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            : null}
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

WykonanieZjazduZDrogi.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WykonanieZjazduZDrogi),
);



// WEBPACK FOOTER //
// src/routes/eservices/WykonanieZjazduZDrogi.js